import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {PricingArea} from '../../data/pricing-area';
import Handsontable from 'handsontable';
import {Subscription} from 'rxjs';
import {ProjectCalcService} from '../../data/project-calc.service';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'app-breakdown-table-sheet',
  templateUrl: './breakdown-table-sheet.component.html',
  styleUrls: ['./breakdown-table-sheet.component.scss']
})
export class BreakdownTableSheetComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  area: PricingArea;

  @Input()
  pricingId: number

  @ViewChild('table')
  tableEl: ElementRef;

  table: Handsontable;

  customTableLoading = true
  progressBarLoading = true;

  breakDownSubj: Subscription;

  constructor(
    private projectCalcService: ProjectCalcService
  ) {
  }

  ngOnInit(): void {
    this.breakDownSubj = this.projectCalcService.breakDownSubj.pipe(debounceTime(500)).subscribe(areaId => {
      this.fillBreakDownData(areaId)
    })
    this.projectCalcService.breakDownSubj.next(this.area.id)
  }


  fillBreakDown() {
    this.table = new Handsontable(this.tableEl.nativeElement, {
      data: [],
      height: 'auto',
      rowHeaders: true,
      rowHeaderWidth: 30,
      colHeaders: ['Name', 'Value'],
      columns: [
        {data: 'name', type: 'text', readOnly: true},
        {data: 'value', type: 'numeric', readOnly: true}
      ],
      colWidths: [200, 200],
      // manualColumnResize: true,
      licenseKey: 'non-commercial-and-evaluation', // for non-commercial use only
      contextMenu: false,
      afterSelectionEnd: () => {
        this.countSelectedCells()
      }
    });
  }

  fillBreakDownData(areaId: number) {
    this.progressBarLoading = true;

    this.projectCalcService.getBreakDownTotals(this.pricingId, areaId).subscribe(breakDownData => {

      this.table.updateData(breakDownData.items)

      this.makeLastTwoLineBold(breakDownData)

      this.customTableLoading = false;
      this.progressBarLoading = false;
    }, () => {
      this.customTableLoading = false;
      this.progressBarLoading = false;
    })
  }

  countSelectedCells() {
    this.projectCalcService.countSelectedCells(this.table)
  }

  makeLastTwoLineBold(breakDownData) {
    if (breakDownData) {
      const totalIndex = breakDownData.items.findIndex(item => item.name === 'Total SQFT Faces')
      const boxesIndex = breakDownData.items.findIndex(item => item.name === 'Boxes Total')

      if (totalIndex >= 0) {
        this.table.setCellMeta(totalIndex, 0, 'className', 'htUpper')
        this.table.setCellMeta(totalIndex, 1, 'className', 'htUpper')
      }
      if (boxesIndex >= 0) {
        this.table.setCellMeta(boxesIndex, 0, 'className', 'htUpper')
        this.table.setCellMeta(boxesIndex, 1, 'className', 'htUpper')
      }
    }

  }

  ngAfterViewInit() {
    this.fillBreakDown()
  }

  ngOnDestroy() {
    if (this.breakDownSubj) {
      this.breakDownSubj.unsubscribe()
      this.breakDownSubj = null;
    }
  }

}
